import { magnitude } from "../dynamics/vector";
import type { ApplyImpulseAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { KineticCoreConfig } from "../types/game-config";
import type { KineticCoreState } from "../types/game-state";
import { getEntityById } from "../utils/entity-helpers";

export function validateImpulse(
  state: KineticCoreState,
  action: ApplyImpulseAction,
  config: KineticCoreConfig,
): ValidationResult {
  if (state.phase !== "RUNNING") {
    return { valid: false, error: "Match is not running" };
  }

  const isKnownParticipant = state.participants.some(
    (participant) => participant.id === action.participantId,
  );
  if (!isKnownParticipant) {
    return { valid: false, error: "Unknown participant" };
  }

  if (action.participantId !== state.currentParticipant) {
    return { valid: false, error: "Not your turn" };
  }

  const entity = getEntityById(state.entities, action.entityId);
  if (!entity) {
    return { valid: false, error: "Entity not found" };
  }

  if (entity.eliminated) {
    return { valid: false, error: "Entity is eliminated" };
  }

  if (entity.owner !== action.participantId) {
    return { valid: false, error: "Cannot control opponent entity" };
  }

  const impulseMagnitude = magnitude(action.impulse);
  if (impulseMagnitude < config.dynamics.minImpulseMagnitude) {
    return {
      valid: false,
      error: "Impulse too weak",
      details: {
        magnitude: impulseMagnitude,
        minimum: config.dynamics.minImpulseMagnitude,
      },
    };
  }

  return { valid: true };
}
